module.exports = __webpack_public_path__ + "img/guide-preview.0f6216e7.png";